import React, { useEffect, useState } from "react";
import Grid from "@mui/material/Grid";
import Box from "@mui/material/Box";
import { Typography } from "@mui/material";
import { getCurrentTimestamp } from "../../../utils/dateUtils";
import ImageScrollPreview from "./Images/ImageScrollPreview";
import ScrollImageModal from "../../common/userFeedback/modals/ScrollImageModal";
import { showAlertWithMessage } from "../../common/userFeedback/CustomAlert";
import { useTheme } from "@emotion/react";

const MassImageApprovalsFrame = ({
  garments,
  selectedGarments,
  setSelectedGarments,
  disabled = false,
  disabledClickFunction = null,
  handleControlClick = () => {},
  reject = true,
  preselectAll = false,
  preDeselectAll = false,
  numberOfColumns = 6,
  toolType,
  disabledClickMessage=null,
  presentedTimestamp=Date.now(),
  imageIndex=1,
  disableGarmentsInGroup=false,
  disablePublishedGarments=true,
  groupRepresentativeBorder=false,
  groupRepresentativeBorderModal=false,
  showTitle=true,
  showBrand=true,
  showGarmentDetailsInModal=true,
  clickToCloseImageModal=true,
  sx={}
}) => {
  const [open, setOpen] = useState(false);
  const [selectedGarment, setSelectedGarment] = useState(null);
  const [selectedIndex, setSelectedIndex] = useState(null);
  const handleOpen = (garment) => {
    setSelectedGarment(garment);
    const idx = garments.findIndex((g) => g.garment_id === garment.garment_id)
    setSelectedIndex(idx >= 0 ? idx : null)
    setOpen(true);
  };
  const [imgXs, setImgXs] = useState(6)
  const [imgHeight, setImgHeight] = useState("10rem")
  const theme = useTheme();
  const handleClose = () => setOpen(false);
  const goToOffset = (delta) => {
    setSelectedIndex((prev) => {
      if (prev === null || prev === undefined) return prev
      const next = prev + delta
      if (next < 0 || next >= garments.length) return prev
      return next
    })
  }
  const handlePrevGarment = () => goToOffset(-1)
  const handleNextGarment = () => goToOffset(1)
  const canGoPrev = selectedIndex !== null && selectedIndex > 0
  const canGoNext = selectedIndex !== null && selectedIndex < garments.length - 1;

  useEffect(() => {
    setImgXs(numberOfColumns <= 6 ? 6 : 12)
    setImgHeight(numberOfColumns <= 4 ? "12rem" : (numberOfColumns <= 6 ? "10rem" : "6rem"))
  }, [numberOfColumns])
  
  useEffect(() => {}, [preselectAll, preDeselectAll]);
  useEffect(() => {
    if (selectedIndex === null || selectedIndex < 0 || selectedIndex >= garments.length) {
      return
    }
    setSelectedGarment(garments[selectedIndex])
  }, [selectedIndex, garments])

  return (
    <Box sx={{ width: "100%", height: "100%", overflow: "auto", ...sx }}>
      <Grid container sx={{ width: "100%", marginRight: 0, userSelect: "none" }}>
        {garments.map((garment) => {
          const isSelected = selectedGarments.some(
            (tag) => tag.garment_id === garment.garment_id
          );
          return (
            <Grid
              item
              id={`garment-${garment.garment_id}`}
              xs={12 / (numberOfColumns + 1)}
              key={garment.garment_id}
              onClick={(e) => {
                if (disableGarmentsInGroup && garment?.is_in_group)
                {
                  showAlertWithMessage("Cannot aggregate this garment - it already belongs in a group.", "warning")
                } else if (disablePublishedGarments && garment?.is_published)
                {
                  showAlertWithMessage("Cannot aggregate this garment - it is a published item.", "warning")
                } else {
                  if ((e.ctrlKey || e.metaKey) && e.shiftKey === false) {
                    // Your specific function for control-click
                    if ((garment.can_change_rep === null || garment.can_change_rep === undefined) || garment.can_change_rep)
                    {
                      // Your specific function for control-click
                      handleControlClick(garment.garment_id);
                    } else {
                      showAlertWithMessage("Cannot change representative to this garment.", "warning")
                    }
                  } else {
                    if (disabled || (disabledClickFunction && disabledClickFunction(garment.garment_id))) {
                      showAlertWithMessage(disabledClickMessage ?? "Click action disabled.", "error")
                      return;
                    }
                    if (isSelected) {
                      setSelectedGarments(
                        selectedGarments.filter(
                          (tag) => tag.garment_id !== garment.garment_id
                        )
                      );
                    } else {
                      setSelectedGarments([
                        ...selectedGarments,
                        {
                          garment_id: garment.garment_id,
                          proposed_timestamp: getCurrentTimestamp(),
                          presented_timestamp: presentedTimestamp,
                        },
                      ]);
                    }
                  }
                }
                
              }}
              onContextMenu={(e) => {
                e.preventDefault();
                handleOpen(garment);
              }}
              sx={{
                display: "flex",
                justifyContent: "center",
                alignItems: "center",
                position: "relative",
                borderRadius: 2,
                border: isSelected
                  ? reject
                    ? `4px ${((garment.can_change_rep === null || garment.can_change_rep === undefined) || garment.can_change_rep) && !(disableGarmentsInGroup && garment?.is_in_group) ? `solid` : `dashed`} ${theme.palette.error[600]}`
                    : `4px ${((garment.can_change_rep === null || garment.can_change_rep === undefined) || garment.can_change_rep) && !(disableGarmentsInGroup && garment?.is_in_group) ? `solid` : `dashed`} ${theme.palette.success[400]}`
                  : ((garment.can_change_rep === null || garment.can_change_rep === undefined) || garment.can_change_rep) && !(disableGarmentsInGroup && garment?.is_in_group) ? `1px solid ${theme.palette.primary[600]}` : (garment.is_published ? `4px dashed ${theme.palette.warning[500]}` : `4px dashed ${theme.palette.primary[700]}`),

                m: 0.5,
                height: "12rem",
                overflow: "hidden",
                cursor: (garment?.is_published || (disableGarmentsInGroup && garment?.is_in_group)) ? "default" : "pointer",
              }}
            >
              <ImageScrollPreview
                images={garment?.images}
                garmentUUID={garment?.uuid_public_id}
                numImages={garment?.num_images}
                image_index={garment?.image_num ?? imageIndex}
                showByIndex={garment?.image_num}
                overlayColour={((garment.can_change_rep === null || garment.can_change_rep === undefined) || garment.can_change_rep) && !(disableGarmentsInGroup && garment?.is_in_group) ? null : (garment.is_published ? `rgba(255, 178, 51, 0.2)` : `rgba(0,0,0,0.2)`)}
                sx={{width: "100%", p: 1 - 0.25 * (numberOfColumns - 4)}}
                imgHeight={imgHeight}
                imgXs={imgXs}
                groupRepresentativeBorder={groupRepresentativeBorder}
              />

              <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  p: 0.5,
                  pb: 0.25,
                  paddingRight: 2,
                  flexDirection: "column",
                  display: "flex",
                  borderBottomRightRadius: 4,
                  backgroundColor: "rgba(255,255,255,0.6)",
                  width: "100%",
                }}
              >
                {showBrand && 
                <Typography variant="body_sm"sx={{flex: 12,
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                  whiteSpace: "nowrap",}}>
                  <b>BRAND:</b> {garment.BRAND}
                </Typography>}
                
                {showTitle && 
                <Typography variant="body_sm" sx={{flex: 12,
                  textOverflow: "ellipsis",
                  overflow: "hidden",
                    whiteSpace: "nowrap",
                  userSelect: "text"}}>
                  <b>TITLE:</b> {garment.title}
                </Typography>}
              </Box>
              {garment.score && <Box
                sx={{
                  position: "absolute",
                  top: 0,
                  left: 0,
                  height: 20,
                  zIndex: 11,
                  pl: 1,
                  pr: 1,
                  pb: 2,
                  borderTopLeftRadius: 4,
                  borderBottomRightRadius: 4,
                  backgroundColor: ((garment.can_change_rep === null || garment.can_change_rep === undefined) || garment.can_change_rep) && !(disableGarmentsInGroup && garment?.is_in_group) ? theme.palette.primary[100] : (garment.is_published ? "rgba(184, 134, 11, 0.75)" : "rgba(0,0,0,0.75)"),
                  color: ((garment.can_change_rep === null || garment.can_change_rep === undefined) || garment.can_change_rep) && !(disableGarmentsInGroup && garment?.is_in_group) ? theme.palette.primary[800] : theme.palette.primary[100],
                }}
              >
                <Typography variant="body_sm">{garment.score}</Typography>
              </Box>}
              
              <Box
                sx={{
                  position: "absolute",
                  display: "flex",
                  bottom: 0,
                  left: 0,
                  height: 20,
                  zIndex: 11,
                  pl: 1,
                  pr: 1,
                  borderRadius: 2,
                  backgroundColor: ((garment.can_change_rep === null || garment.can_change_rep === undefined) || garment.can_change_rep) && !(disableGarmentsInGroup && garment?.is_in_group) ? theme.palette.primary[100] : (garment.is_published ? "rgba(184, 134, 11, 0.75)" : "rgba(0,0,0,0.75)"),
                  color: ((garment.can_change_rep === null || garment.can_change_rep === undefined) || garment.can_change_rep) && !(disableGarmentsInGroup && garment?.is_in_group) ? theme.palette.primary[800] : theme.palette.primary[100],
                  userSelect: "text",
                }}
              >
                <Typography variant="body_sm">
                  <b>ID:</b> {garment.garment_id}
                </Typography>
              </Box>
            </Grid>
          );
        })}
      </Grid>
      <ScrollImageModal
        handleClose={handleClose}
        openModal={open}
        images={selectedGarment?.images}
        numImages={selectedGarment?.num_images}
        garmentUUID={selectedGarment?.uuid_public_id}
        groupRepresentativeBorder={groupRepresentativeBorderModal}
        groupRepresentativeBorderIndex={selectedGarment?.image_num - 1}
        garment={selectedGarment}
        showGarmentDetails={showGarmentDetailsInModal}
        clickToClose={clickToCloseImageModal}
        onPrev={handlePrevGarment}
        onNext={handleNextGarment}
        canGoPrev={canGoPrev}
        canGoNext={canGoNext}
        sx={{}}
      />
    </Box>
  );
};

export default MassImageApprovalsFrame;
